export default __webpack_public_path__ + "static/media/strateg.2b7d442b.png";